import { Component } from '@angular/core';
import { LenderService } from '@shared/service/lender/lender.service';
import { LenderConfiguration } from '@shared/model/lender-config.model';

@Component({
  selector: 'dx-user-verification-error',
  templateUrl: './user-verification-error.component.html'
})
export class UserVerificationErrorComponent {
  /** Lender configuration data */
  public lenderConfig: LenderConfiguration;

  constructor(public lenderService: LenderService) {
    this.lenderConfig = this.lenderService.lenderDataInfo;
  }
}
